<template>
  <footer class="site__footer">
    <div class="progress">
      <div v-if="displayRemaining(answer)" class="question-num">
        あと<span>{{ displayRemaining(answer) }}</span>問
      </div>
      <div v-if="!displayRemaining(answer)" class="question-num">
        あと<span>0</span>問
      </div>
      <div class="progress__inr">
        <div class="progress__bar" :style="progressBar"></div>
      </div>
    </div>
    <p class="copyright center"><small>Copyright © 株式会社ネオキャリア All Rights Reserved.</small></p>
    <p class="site__footer__caption">
      <small>
        ※1 2021/04/01-2024/03/31の間で弊社を通じて内定獲得された方 ※2 2023/03/01-2024/02/31の間で弊社を通じて内定獲得された方 ※3 2023/3/1~2024/2/29までの1年間で弊社にて面談された方
      </small>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'ChatFooter',
  props: {
    total: {
      type: Number,
      required: true
    },
    answer: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      progressBar: {
        width: 0
      }
    }
  },
  watch: {
    answer: function (val) {
      if (Number(val) <= this.total) {
        let progress = (Number(val) / this.total) * 100
        this.progressBar.width = `${progress.toFixed(1)}%`
      } else {
        this.progressBar.width = '100%'
      }
    }
  },
  methods: {
    displayRemaining: function (answer) {
      const c = this.total - Number(answer)
      return c <= 0 ? 0 : c
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChatFooter.vue